import { keepPreviousData } from "@tanstack/react-query"
import {
	getUserGetUserProfileQueryOptions,
	useUserGetUserProfile,
} from "@/shared/api/generated/user/user"
import { GetUserProfileResponse } from "@/shared/api/generated/user/user.zod"
import { validateSuccessResponse } from "@/shared/lib/zod-validation-helpers"
import type { QueryHookOptions } from "@/shared/typings"
import { USER_STALE } from "../consts"

export function getUserProfileQueryOptions(options?: QueryHookOptions) {
	return getUserGetUserProfileQueryOptions({
		query: {
			...options,
			staleTime: USER_STALE,
		},
	})
}

export function useUserProfile(options?: QueryHookOptions) {
	return useUserGetUserProfile({
		query: {
			placeholderData:
				(options?.keepPreviousData ?? true) ? keepPreviousData : undefined,
			enabled: options?.enabled ?? true,
			staleTime: USER_STALE,
			select(data) {
				const result = validateSuccessResponse(GetUserProfileResponse, data)
				return result
			},
		},
	})
}
